import { render, staticRenderFns } from "./Resources-hero.vue?vue&type=template&id=76757fd6&scoped=true&"
import script from "./Resources-hero.vue?vue&type=script&lang=js&"
export * from "./Resources-hero.vue?vue&type=script&lang=js&"
import style0 from "./Resources-hero.vue?vue&type=style&index=0&id=76757fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76757fd6",
  null
  
)

export default component.exports